import React, {ReactNode} from 'react';
import clsx from "clsx";

interface CouponsAmountBadgeProps {
    amount: number;
    active: boolean;
    children: ReactNode;
}

const CouponsAmountBadge = (props: CouponsAmountBadgeProps) => {
    const {amount, active, children} = props;

    return (
        <div>
        <div className={
            clsx("absolute right-0 top-0 mt-[4px] mr-[4px] min-w-[18px] h-[18px] tablet:min-w-[24px] tablet:h-[24px] rounded-[50%] flex-shrink-0 flex items-center justify-center p-0 text-white", active ? "py-[10px] bg-red" : "t-[50%] py-[10px] bg-[#727374]")
        }>
            {amount}
        </div>
            {children}
        </div>
    );
};
export default CouponsAmountBadge;
